import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_ds_storage_alertsService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { fullTextSearch?: string, application_name?: string, alert_name?: string, level?: number, enabled?: boolean, $top?: number, $skip?: number }): Promise<{ result?: { alert_id?: string, application_name?: string, alert_name?: string, level?: number, enabled?: boolean, to?: string, cc?: string, bcc?: string, subject?: string, pdf?: boolean, created_on?: string, created_by?: string, modified_on?: string, modified_by?: string }[], totalCount?: number }> {

    let url = `${environment.backendUrl}api/Notifications/datasources/ds_storage_alerts/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { fullTextSearch?: string, application_name?: string, alert_name?: string, level?: number, enabled?: boolean, $keys: string[] }): Promise<{ result?: { alert_id?: string, application_name?: string, alert_name?: string, level?: number, enabled?: boolean, to?: string, cc?: string, bcc?: string, subject?: string, pdf?: boolean, created_on?: string, created_by?: string, modified_on?: string, modified_by?: string }[] }> {

    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Notifications/datasources/ds_storage_alerts/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
}

